export class TimeConversionHelper {
    /**
     * Convertit des millisecondes en heures
     * @param value : Valeur à convertir.
     * @returns : La valeur convertie en heures
     */
    public static convertMillisecondesInHours(value: number): number {
        return Math.ceil(value / (1000 * 3600));
    }

    /**
     * Convertit des heures en jours
     * @param value : Valeur à convertir.
     * @returns : La valeur convertie en jours
     */
    public static convertHoursInDays(value: number): number {
        return Math.ceil(value / 24);
    }

    /**
     * Convertit des jours en heures
     * @param value : Valeur à convertir.
     * @returns : La valeur convertie en heures
     */
    public static convertDaysInHours(value: number): number {
        return value * 24;
    }

    /**
     * Convertit des millisecondes en minutes
     * @param value : Valeur à convertir.
     * @returns : La valeur convertie en heures
     */
    public static convertMillisecondsInMinuts(value: number): number {
        return Math.floor(value / (1000 * 60));
    }
}
